import SurveyList from '../features/Survey/route';

interface RouterProps {
    path: string;
    element: React.ReactNode;
}

const RoutesList: RouterProps[] = [...SurveyList];

export default RoutesList;
